/**
 * Generic utility for removing filter values from filter objects
 */
export function removeFilterValue<T>(filters: T, filterKey: keyof T, value?: unknown): T {
  const updated = { ...filters };

  if (value === undefined) {
    delete updated[filterKey];
  } else {
    const currentValue = updated[filterKey];
    if (Array.isArray(currentValue)) {
      const filtered = currentValue.filter(
        (item) =>
          item !== value ||
          ((value as { value?: unknown })?.value != undefined &&
            (item as { value?: unknown })?.value !== (value as { value?: unknown })?.value),
      );
      if (filtered.length === 0) {
        delete updated[filterKey];
      } else {
        updated[filterKey] = filtered as T[keyof T];
      }
    } else {
      // For non-array filters, just delete the entire filter
      delete updated[filterKey];
    }
  }

  return updated;
}
